
export class R2MAccess {

    private url = 'https://r2m.marietta.dev/api/v1/player';

    constructor() {}

    public post(): Promise<any | void> {
        console.log(`URL: ${this.url}\n`);
        console.log(`\POST Method`);

        const controller = new AbortController();
        const timeout = setTimeout(() => { controller.abort() }, 10000);

        return fetch(this.url, { method: 'POST',
                                     mode: 'cors',
                                     cache: "no-store",
                                     headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({webcad:true}),
                                    signal: controller.signal })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                if (response.status == 404) {
                    return response.json();
                }
                if (!response.ok) {
                    const object = response.json();
                    console.error('response.ok:', response.ok);
                    console.error('esponse.status:', response.status);
                    console.error('esponse.statusText:', response.statusText);
                    throw new Error(response.statusText);
                  }
                return Promise.reject(new Error(`${response.status}: ${response.statusText}`));
            })
            .catch((error) => {
                return Promise.reject(new Error(error));
            });
    }

    public get(userID: string): Promise<any | void> {
        console.log(`URL: ${this.url}\n`);
        console.log(`\tGET Method`);

        const controller = new AbortController();
        const timeout = setTimeout(() => { controller.abort() }, 10000);

        const getURL = `${this.url}/${userID}`;

        return fetch(getURL, { method: 'GET',
                                 mode: 'cors',
                                 cache: "no-store",
                                 signal: controller.signal })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                if (response.status == 404) {
                    return response.json();
                }
                if (!response.ok) {
                    const object = response.json();
                    console.error('response.ok:', response.ok);
                    console.error('esponse.status:', response.status);
                    console.error('esponse.statusText:', response.statusText);
                    throw new Error(response.statusText);
                  }
                return Promise.reject(new Error(`${response.status}: ${response.statusText}`));
            })
            .catch((error) => {
                return Promise.reject(new Error(error));
            });
    }
}
